import {
  Alert,
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  Typography
} from '@mui/material';
import { keywordResearchDashBoardCss } from '../../keywordResearch/keywordResearchCSS';
import { GMBTutorialLinks, localSeoTexts } from '../../localSeo/localSeoTexts';
import { keywordOverviewTexts, paths } from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import {
  keywordOverviewCss,
  snackBar
} from '../../keywordResearch/keywordOverview/keywordOverviewCSS';
import {
  getWindowInnerHight,
  openNewTab
} from 'src/common/config/FunctionHelper';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { addLocalSEOTag } from 'src/common/Scraper';
import { useState } from 'react';

export const ComingSoonCitationBuilder = () => {
  const [error, setError]: any = useState(false);
  const [loading, setLoading]: any = useState(false);
  const navigate = useNavigate();
  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        //dispatch(setLocalSeoSection(1));
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.citationBuilder}
    </Typography>
  ];

  const getMailChimpCall = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const response: any = await addLocalSEOTag();
    setLoading(null);
    setError(response);
    setTimeout(() => {
      setError(null);
    }, 5000);
  };

  const handleCloseBackLinkSnackBar = () => {
    setError(null);
  };
  return (
    <>
      {error?.status && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={error?.status}
          autoHideDuration={5000}
          onClose={handleCloseBackLinkSnackBar}
        >
          <Box>
            <Alert
              icon={
                error?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleCloseBackLinkSnackBar}
              severity={error?.status}
              variant="filled"
              sx={{
                ...(error?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  error?.status === 'success'
                    ? 'var(--color-success-bg-ultra)'
                    : 'var(--color-error-bg)',
                border:
                  error?.status === 'success'
                    ? '1px solid var(--color-success-border)'
                    : '1px solid var(--color-error-red)',
                maxWidth: '667px'
              }}
            >
              {error?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid
          item
          xs={12}
          sx={{
            padding: 0,
            paddingLeft: '32px'
          }}
        >
          <div style={{ minHeight: getWindowInnerHight() }}>
            <Box sx={keywordOverviewCss?.breadcrumbsMainBox}>
              <Box>
                {/*{localSeoSection == 2 && (*/}
                <Breadcrumbs
                  separator={
                    <NavigateNextIcon
                      fontSize="small"
                      sx={keywordResearchDashBoardCss?.navigateNextIcon}
                    />
                  }
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
                {/*)}*/}
              </Box>
              {/* {bulkKeywordDifficultyReduxData && ( */}
              <Box sx={keywordOverviewCss?.userTutorialBox}>
                {/*<img
                  onClick={() => {
                    openNewTab(
                      keywordOverviewTexts?.keywordResearchTutorialsLink
                    );
                  }}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/keyword/book-open-02.svg`
                  }
                  alt="icon"
                />
                <Typography
                  onClick={() => {
                    openNewTab(GMBTutorialLinks?.localSeoTutorial);
                  }}
                  sx={keywordOverviewCss?.userTutorial}
                >
                  {localSeoTexts?.citationBuilderTutorial}
                </Typography>*/}
              </Box>
              {/* )} */}
            </Box>
            <Box
              sx={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
                backgroundImage:
                  'url(/static/images/icons/local-seo/citation-bg.png)',
                backgroundSize: 'cover', // or 'contain' based on your need
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                marginTop: '24px',
                marginBottom: '24px',
                minHeight: '565px',
                paddingTop: '32px'
              }}
            >
              <Box
                sx={{
                  gap: '32px',
                  borderRadius: '12px',
                  padding: '32px',
                  width: '100%',
                  maxWidth: '828px',
                  backgroundColor: 'var(--color-white)',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: 'var(--font-size-20)',
                    lineHeight: 'var(--line-height-30)',
                    textAlign: 'center',
                    color: 'var(--color-primary)',
                    marginBottom: '12px'
                  }}
                >
                  {'Citation Builder - Coming Soon'}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 'var(--font-size-16)',
                    lineHeight: 'var(--line-height-24)',
                    textAlign: 'center',
                    color: 'var(--color-text-mid)',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '100%',
                    maxWidth: '500px',
                    marginBottom: '32px'
                  }}
                >
                  {
                    'Find, fix, and build local citations - all from your dashboard. Scan citations for free now and build your campaign.'
                  }
                </Typography>
                <img
                  draggable={false}
                  src="/static/images/icons/local-seo/citation-modal-bg.png"
                  alt="image"
                />
                <Button
                  variant="contained"
                  sx={{
                    maxHeight: '44px',
                    maxWidth: '281px',
                    minWidth: '281px',
                    gap: '8px',
                    padding: '12px 32px 12px 32px',
                    borderRadius: '6px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '32px',
                    mx: 'auto', // this centers the button horizontally
                    display: 'block' // ensures mx auto applies
                  }}
                  onClick={getMailChimpCall}
                >
                  {loading ? (
                    <CircularProgress sx={{ color: 'var(--color-white)' }} size={24} />
                  ) : (
                    <>{'Join the waitlist'}</>
                  )}
                </Button>
              </Box>
            </Box>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
